import { Directive, ViewContainerRef, TemplateRef, Input, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { FeatureFlagService } from './feature-flag.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export interface Flag {
    id: number;
    key: string;
    value: string;
    type: string;
    visibility: number;
    group: string;
}

@Directive({
    selector: '[appFeatureFlag]',
})
export class FeatureFlagDirective implements OnInit, OnDestroy  {
    @Input('appFeatureFlag') featureFlag: string;
    hasRendered = false;
    destroy$: Subject<void> = new Subject<void>();

    constructor(
      private vcr: ViewContainerRef,
      private tpl: TemplateRef<any>,
      private flagService: FeatureFlagService
    ) { }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.flagService.hasFeatureFlag(this.featureFlag).pipe(takeUntil(this.destroy$)).subscribe(hasAccess => {
            // enable flag feature in dev and test enviromnet and check for access otherwise
            if (hasAccess || environment.envName === 'dev' || environment.envName === 'test') {
                if (!this.hasRendered) {
                    this.hasRendered = true; // prevents multiple renders when there are multiple callbacks
                    this.vcr.createEmbeddedView(this.tpl); // manually render HTML elements
                }
            }
        });
    }
}
